import { AbstractDto, ReadField } from "./AbstractDto";

export default class TagResult extends AbstractDto<TagResult> {
    @ReadField
    public tag: string;
    @ReadField
    public hash: string | undefined;
    @ReadField
    public points: number | undefined;
    @ReadField
    public passDate: Date | undefined;
    @ReadField
    public lastDate: Date | undefined;
    @ReadField
    public maxPoints: number;
    @ReadField
    public required: boolean;
    @ReadField
    public isBonus: boolean;
    @ReadField
    public threshold: number;
    @ReadField
    public dueDate: Date;
    @ReadField
    public output: string;

    constructor(tag: string,
                hash?: string,
                points?: number,
                passDate?: Date,
                lastDate?: Date) {

        super();

        this.tag = tag;
        this.hash = hash;
        this.points = points;
        this.passDate = passDate;
        this.lastDate = lastDate;
    }

}
